import { Menu, Bell, Globe, LogOut, Sun, User, LogIn, Thermometer } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { useUIStore } from '../stores/uiStore';
import { useTranslation } from '../i18n/config';
import { ProjectSwitcher } from './ProjectSwitcher';
import { TenantBadge } from './TenantBadge';
import { SimClockChip } from './SimClockChip';

export function Header() {
  const { user, logout } = useAuthStore();
  const { language, setLanguage, toggleSidebar, tempUnit, toggleTempUnit } = useUIStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <header className="h-16 bg-dark-900 border-b border-dark-700 flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        <button onClick={toggleSidebar} className="text-dark-400 hover:text-white transition-colors">
          <Menu className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-3">
          <img src="/beai-logo.jpg" alt="BeAI Energy" className="h-8 rounded" />
          <Sun className="w-5 h-5 text-solar-400" />
          <span className="text-lg font-display font-bold gradient-text">InverterAI</span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <TenantBadge />
        <SimClockChip />
        <ProjectSwitcher />

        <button
          onClick={toggleTempUnit}
          className="flex items-center gap-1 text-dark-400 hover:text-white transition-colors text-sm"
          title={tempUnit === 'C' ? 'Switch to °F' : 'Switch to °C'}
        >
          <Thermometer className="w-4 h-4" />
          °{tempUnit}
        </button>

        <button
          onClick={() => setLanguage(language === 'es' ? 'en' : 'es')}
          className="flex items-center gap-1 text-dark-400 hover:text-white transition-colors text-sm"
        >
          <Globe className="w-4 h-4" />
          {language.toUpperCase()}
        </button>

        <button className="relative text-dark-400 hover:text-white transition-colors">
          <Bell className="w-5 h-5" />
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full text-[8px] flex items-center justify-center">
            3
          </span>
        </button>

        {user ? (
          <div className="flex items-center gap-3 border-l border-dark-700 pl-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-primary-600 flex items-center justify-center">
                <User className="w-4 h-4 text-white" />
              </div>
              <div className="text-sm">
                <div className="font-medium">{user.username}</div>
                <div className="text-dark-400 text-xs capitalize">{user.role}</div>
              </div>
            </div>
            <button
              onClick={logout}
              className="text-dark-400 hover:text-red-400 transition-colors"
              title={t('auth.logout')}
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        ) : (
          <button
            onClick={() => navigate('/login')}
            className="flex items-center gap-2 border-l border-dark-700 pl-4 text-dark-400 hover:text-primary-400 transition-colors text-sm"
          >
            <LogIn className="w-4 h-4" />
            {t('auth.login')}
          </button>
        )}
      </div>
    </header>
  );
}
